import React from 'react';
import AdminAuth from '../components/admin/AdminAuth';
import InstagramDashboard from '../components/admin/InstagramDashboard';

const InstagramAdminPage = () => {
  return (
    <AdminAuth>
      <InstagramDashboard />
    </AdminAuth>
  );
};

export default InstagramAdminPage;
